import React from "react";
import { Link } from "react-scroll";

const Banner = () => {
  return (
    <div className="row gx-0 align-items-center mb-5 mb-md-0">
      <div
        className="col-md-6 ps-md-5 py-md-5 order-1 order-md-0"
        id="bannerFirstDiv"
      >
        <div className="ms-5 py-md-4">
          <h2 style={{ fontSize: "3rem", fontWeight: "bold" }}>
            I'm Vinay Singh, a
          </h2>
          <h1 style={{ fontSize: "3.5rem", fontWeight: "bold" }}>
            Full Stack
            <span style={{ color: "rgb(103,61,255)" }}> Developer</span>
          </h1>
          <p style={{ fontSize: "1.4rem" }} className="py-3 pe-3 text-muted">
            My mission is to help your business grow through my
            conversion-focused branding, design, marketing, and communication
            expertise.
          </p>

          <div className="d-flex">
            <Link to="targetProject" spy={true} smooth={true}>  
            <button className="navBtnLinks m-0 d-none d-md-block"> Discover My Work </button>
            </Link>
            <a href="images/Resume.pdf" download>
              <button className="navBtnLinks m-0 mx-md-4 px-3">
                Download Resume
              </button>
            </a>
          </div>
        </div>
      </div>
      <div className="col-md-6 ps-md-5 py-5 text-center order-0 order-md-1">
        <div className="" id="bannerSecondDiv">
          <img
            src="images/profile.png"
            id="bannerImg"
            className="img-fluid w-50"
            alt=""
            srcset=""
          />
        </div>
      </div>
    </div>
  );
};

export default Banner;
